// Image preloader utility for faster image loading

const imageCache = new Map();

// Preload a single image
export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    // Check cache first
    if (imageCache.has(src)) {
      resolve(imageCache.get(src));
      return;
    }

    const img = new Image();
    img.onload = () => {
      imageCache.set(src, img);
      resolve(img);
    };
    img.onerror = reject;
    img.src = src;
  });
};

// Preload multiple images in parallel
export const preloadImages = async (urls) => {
  try {
    await Promise.all(urls.map(url => preloadImage(url).catch(() => null)));
  } catch (error) {
    console.error('Error preloading images:', error);
  }
};

// Preload images with priority (load first N images first)
export const preloadImagesWithPriority = async (urls, priorityCount = 3) => {
  const priorityUrls = urls.slice(0, priorityCount);
  const remainingUrls = urls.slice(priorityCount);

  // Load priority images first
  await preloadImages(priorityUrls);

  // Load remaining images in background
  if (remainingUrls.length > 0) {
    preloadImages(remainingUrls).catch(() => null);
  }
};

// Clear image cache
export const clearImageCache = () => {
  imageCache.clear();
};
